export default "<app-card class=\"text-center\">\n  <h1>Seja bem vindo!</h1> \n  <h4><small>Acesse o menu!</small></h4>\n</app-card>\n"